<template>
  <div>
    <CardContainer>
      <div style="display: grid; grid-template-columns: 1fr auto;">
        <!--        <span>-->
        <!--          <el-upload-->
        <!--            class="my-btn"-->
        <!--            action=""-->
        <!--            accept=".xls, .xlsx"-->
        <!--            :show-file-list="false"-->
        <!--            :http-request="handleSearch"-->
        <!--          >-->
        <!--            <hl-button>{{ $t('Fota.batchQuery') }}</hl-button>-->
        <!--          </el-upload>-->
        <!--          <hl-button type="text" @click="handleTemplate">-->
        <!--            {{ $t('Fota.excelTemplate') }}<i class="el-icon-bottom" style="font-size: 14px;"></i>-->
        <!--          </hl-button>-->
        <!--        </span>-->
        <CommonForm @search="formSearch" :form-json="formjson" />
      </div>
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        @change="handleTableChange"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
  </div>
</template>

<script>
import tablejson from './Model/DeviceTablejson.Index'
import formjson from './Model/DeviceFormjson.Index'
import formTableMixin from '@/mixins/formTableMixin'
import { downloadFile } from '@/utils/download'
import getRoleFromPath from '@/mixins/getRoleFromPath'

export default {
  mixins: [formTableMixin],
  data() {
    return {
      tablejson,
      formjson,
      row: {},
      queryApi: this.$api.fota.firmware_device_page,
      importTemplateApi: this.$api.fota.firmware_device_excel_template,
      importApi: this.$api.fota.firmware_device_excel_upload
    }
  },
  methods: {
    formSearch(data) {
      data.firmwareType = 'DTU'
      this.search(data, null, this.queryApi)
    },
    handleSearch(res) {
      let formdata = new FormData()
      formdata.append('deviceFile', res.file)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      this.$ajax.post(this.importApi, formdata, config).then((res) => {
        if (res.success) {
          let key = res.data
          this.$ajax
            .download(this.$api.fota.firmware_device_excel_download, {
              key: key
            })
            .then((res) => {
              downloadFile(res)
            })
        }
      })
    },
    handleTemplate() {
      this.$ajax.download(this.importTemplateApi).then((res) => {
        downloadFile(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-btn {
  margin-right: 16px;
  display: inline-block;
}
</style>
